import React, { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import { Menu, X, ShoppingCart } from 'lucide-react';

export const Navbar = ({ onNavigate }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Products', target: 'products' },
    { label: 'Masterclass', target: 'class' },
    { label: 'Contact', target: 'contact' }
  ];

  const handleNavClick = (target) => {
    onNavigate(target);
    setIsMobileMenuOpen(false);
  };

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass py-3' : 'py-5'
      }`}
    >
      <div className="container-custom flex items-center justify-between">
        {/* Logo */}
        <a 
          href="/" 
          className="flex items-center gap-2 hover:opacity-80 transition-opacity"
          data-testid="nav-logo"
          aria-label="Winamor Australia - Home"
        >
          <img 
            src="https://customer-assets.emergentagent.com/job_smart-iron-funnel/artifacts/yx8h504c_logo%20transparent%20good%20%20%28Stickers%20%28Square%29%29%20%283%29.png" 
            alt="Winamor Australia - Best Keratin Iron Logo"
            className="h-10 w-10"
          />
          <span className="text-2xl font-bold text-white">WINAMOR</span>
        </a>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.target}
              onClick={() => handleNavClick(link.target)}
              className="nav-link"
              data-testid={`nav-${link.target}`}
            >
              {link.label}
            </button>
          ))}
          
          <Button 
            onClick={() => handleNavClick('products')}
            className="btn-primary flex items-center gap-2"
            data-testid="nav-shop-btn"
          >
            <ShoppingCart className="w-4 h-4" />
            Shop Now
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden p-2 text-white"
          data-testid="mobile-menu-btn"
        >
          {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden glass mt-2 mx-4 rounded-xl p-6 animate-fade-in-up">
          <div className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <button
                key={link.target}
                onClick={() => handleNavClick(link.target)}
                className="nav-link text-left py-2"
                data-testid={`mobile-nav-${link.target}`}
              >
                {link.label}
              </button>
            ))}
            <Button 
              onClick={() => handleNavClick('products')}
              className="btn-primary w-full mt-2"
              data-testid="mobile-shop-btn"
            >
              <ShoppingCart className="w-4 h-4 mr-2" />
              Shop Now
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
